.bj{justify-content:flex-end;}